import React from 'react';
import ReactDOM from 'react-dom/client';

import './App.css';
import App from './App.tsx';

const RELOAD_KEY = 'c-reload';
const reload = () => window.location.replace(window.location.href + '?_t=' + Date.now());

window.addEventListener('error', (e) => {
  if (
    e.message?.includes('Failed to fetch dynamically imported module') ||
    e.message?.includes('Importing a module script failed')
  ) {
    e.preventDefault();
    const n = Number(sessionStorage.getItem(RELOAD_KEY) || '0');
    sessionStorage.setItem(RELOAD_KEY, String(n + 1));
    if (n < 2) reload();
  }
});

window.addEventListener('load', () => sessionStorage.removeItem(RELOAD_KEY));


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);